<template>
	<div class="baseItemBox text-white">
		<div>
			<BlockBox title="回收物品重量统计(kg)" enTitle="Recovery" height="306">
				<template #content>
					<div class="tabBox" >
						<div class="menuBox flex align-center justify-center">
							<div class="menuItem " :class="index==zlDataTabIndex?'checked':''"
								v-for="(item,index) in zlDataTab" :key="index" @click="zlDataTabClck(index)">
								{{ item.name }}
							</div>
						</div>
					</div>
					<div style="height:200px;padding:0 0;box-sizing: border-box">
						<dv-scroll-board :config="zlDataConfig" style="width:100%;height:230px" />
					</div>
				</template>
			</BlockBox>
		</div>
		<div class="margin-top-15">
			<BlockBox title="回收分拣中心收货明细(站点)" enTitle="Harvest Details" height="395">
				<template #content>
					<div style="padding:0 0;box-sizing: border-box">
						<div class="custlbBox" style="height:355px;">
							<dv-scroll-board :config="mdshmxConfig" style="width:100%;height:355px" />
						</div>
					</div>
				</template>
			</BlockBox>
		</div>
        <div class="margin-top-15">
            <BlockBox title="出库统计" titleType="right" enTitle="Outbound Statistics" height="265">
                <template #titleLabel>
                    <div class="custDate flex align-center justify-center">
                        <el-date-picker value-format="yyyy-MM" :clearable="false" v-model="ckMonth"
                            @change="dataChangeCk" type="month" size="mini" placeholder="选择月">
                        </el-date-picker>
                        </div>
                </template>
                <template #content>
                    <div style="padding:20 15px 0 15px;box-sizing: border-box">
                        <div id="chartCddjtj" style="height:200px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>


	</div>
</template>

<script>
	import echartMixins from "@/utils/resizeMixins";
	import BlockBox from '@/views/components/blockBox'
	// import notice from '@/assets/img/notice.png'
	// import 'swiper/swiper-bundle.min.css'
	// import Swiper from 'swiper/swiper-bundle';
	import {
        ptstatisticsBoardCategory,
        ptLeftData,
        ptStatisticsOutSite
	} from "@/api/api";
	export default {
		name: "cityGreenLand",
		components: {
			BlockBox
		},
		mixins: [echartMixins],
		data() {
			return {
				item: {},
				// dkList: [],
				// mrhnDay: ['12/05', '12/06', '12/07', '12/08', '12/09'],
				// 调整开始************
				// notice,
				zlDataTab: [{
					id: "1",
					name: "全年"
				}, {
					id: "2",
					name: "本月"
				}, {
					id: "3",
					name: "全天"
				}],
				zlDataTabIndex: 0,
				zlDataConfig: {
					header: ['名称', '数量'],
					indexHeader: "序号",
					data: [],
					index: true,
					columnWidth: [60, 240]
				},
				mdshmxConfig: {
					header: ['时间', '门店', '品类', '重量', '金额', '减碳量kg'],
					indexHeader: "序号",
					data: [],
					index: true,
					columnWidth: [70, 110, 100, 100]
				},
				swiperShow:false,
				timerLeft:null,
                 ckMonth:"",
			}
		},
		
		mounted() {
			this.getStatisticsBoardCategoryData();
			this.changeDataTwo();
            this.getptStatisticsOutSite()
			this.timerLeft = setTimeout(() => {
			  this.getStatisticsBoardCategoryData();
			  this.changeDataTwo();
              this.getptStatisticsOutSite()
			}, 60000);
	
		},
		  beforeDestroy() {
		    clearTimeout(this.timerLeft);
		  },
		methods: {
            async getStatisticsBoardCategoryData() {
                let _self = this
                await ptstatisticsBoardCategory({
                    type: _self.zlDataTab[_self.zlDataTabIndex].id,
                    siteId: _self.siteId
                }).then(res => {
                    let list = [];
                    if (res.data.list != null && res.data.list.length > 0) {
                        res.data.list.forEach(obj => {
                            list.push([obj.name, '<span class="text-color-yellow">' + obj.price +
                                '</span>', '<span class="text-color-blue">' + obj.weight +
                                '</span>'
                            ]);
                        })
                    }
                    _self.zlDataConfig = {
                        header: ['名称', '金额(元)', '数量(kg)'],
                        indexHeader: "序号",
                        oddRowBGC: 'rgba(5,38,117,0.5)',
                        evenRowBGC: 'rgba(9,79,200,0.1)',
                        data: list,
                        index: true,
                        columnWidth: [60, 140]
                    };
                })
            },
			changeDataTwo() {
				let _self = this
                 _self.getCurrentMonth()
				ptLeftData().then(res => {
					let list = [];
					// _self.dkList = res.data.memberList;
					// _self.swiperShow=true
					// _self.$nextTick(()=>{
					// 	_self.initSwiper()
					// })
					if (res.data.list != null && res.data.list.length > 0) {
						res.data.list.forEach( obj => {
							
							list.push([obj.create_time, obj.site_name, obj.name,'<div class="text-color-blue text-center">'+obj.net_weight+'</div>',
								'<div class="text-color-yellow text-center">'+obj.price+'</div>', '<div class="text-color-green text-center">'+obj.dayWeight+'</div>'
							]);
							
						})
					}
					_self.mdshmxConfig = {
						header: ['时间', '站点', '品类', '重量(kg)', '金额(元)', '今日收货量(kg)'],
						data: list,
						rowNum:7,
                        oddRowBGC:'rgba(5,38,117,0.5)',
                        evenRowBGC:'rgba(9,79,200,0.1)',
						columnWidth: [100,65,54,60,63]
					};
					
					
						
				});
			},
			// 方法开始
			zlDataTabClck(index) {
				this.zlDataTabIndex = index;
				this.getStatisticsBoardCategoryData();
			},
            getptStatisticsOutSite(){
                let _self=this
                ptStatisticsOutSite({month: _self.ckMonth}).then(res=>{
                    _self.cktjList=res.data.list
                    _self.$nextTick(function() {
                        _self.drawCddjtj();
                    });
                })
            },
            drawCddjtj() {
                this.chart = this.$echarts.init(document.getElementById("chartCddjtj"));
                let dateList = [];
                let dateValue = [];
                if (this.cktjList && this.cktjList.length > 0) {
                    this.cktjList.forEach(item => {
                        dateList.push(item.site_name);
                        dateValue.push(item.weight);
                    })
                }
                let option = {
                    grid: {
                        left: '3%',
                        right: '3.5%',
                        bottom: '3%',
                        top: 20,
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    xAxis: {
                        type: 'category',
            
                        axisTick: {
                            show: false,
                        },
                        data: dateList,
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
                                fontSize: 10 //更改坐标轴文字大小
                            }
                        },
                        splitLine: { //网格线
                            lineStyle: {
                                type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
                                color: ['rgba(45,163,255,0.1)']
                            },
                            show: true //隐藏或显示
                        },
                        axisLine: {
                            show: false, //隐藏或显示
                            lineStyle: {
                                color: '#2da3ff'
                            }
                        }
                    },
                    yAxis: {
                        type: 'value',
                        axisTick: {
                            show: false,
                        },
                        axisLabel: {
                            textStyle: {
                                color: 'rgba(255,255,255,0.7)', //更改坐标轴文字颜色
                                fontSize: 10 //更改坐标轴文字大小
                            }
                        },
                        splitLine: { //网格线
                            lineStyle: {
                                type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
                                color: ['rgba(45,163,255,0.1)']
                            },
                            show: true //隐藏或显示
                        },
                        axisLine: {
                            show: false, //隐藏或显示
                            lineStyle: {
                                color: '#ffffff',
                                fontSize: 10
                            }
                        }
                    },
                    series: [{
                        name: '重量/千克',
                        type: 'bar',
                        barWidth: 9,
                        data: dateValue,
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: {
                                        //数值样式
                                        color: 'white',
                                        fontSize: 12,
                                    },
                                },
                                color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                            offset: 0,
                                            color: 'rgba(1, 108, 190, 1)', // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
                                        }
                                    ],
                                    global: false, // 缺省为 false
                                }
                            }
                        },
            
                    }, ]
                };
                // echart图表自适应
                this.chart.setOption(option)
                window.addEventListener("resize", () => {
                    this.chart.resize();
                });
            },
            getCurrentMonth() {
                  const now = new Date();
                  const month = now.getMonth() + 1; // 月份是从0开始的，所以需要+1
                  const year =now.getFullYear()
                  this.ckMonth = year+'-'+month
            },
            dataChangeCk(){
                console.log(this.ckMonth,'ckmmmm')
                this.getptStatisticsOutSite()
            }
            
			// initSwiper() {
			// 	new Swiper('.swiper', {
			// 		autoplay: true, //可选选项，自动滑动
			// 		direction: 'vertical',
			// 		height: 200, //你的slide高度
			// 		slidesPerView: 4,
			// 	})
			// }

		}
	}
</script>
<style>
	.dv-scroll-board .rows .ceil{padding:0 2px!important;}
	.dv-scroll-board .header .header-item{padding:0 2px!important;}
</style>

<style lang="scss">
	// .baseItemBox {
	// 	min-height: 500px;
	// 	padding: 14px 15px 15px 15px;
	// 	box-sizing: border-box;

	// 	.shtjItem {
	// 		width: 100%;
	// 		height: 38px;
	// 		line-height: 38px;
	// 		border: 1px solid #155898;
	// 		line-height: 38px;
	// 		padding: 0 5px;
	// 		box-sizing: border-box;
	// 		cursor: pointer;
	// 	}

	// 	.shtjItem:hover {
	// 		background: #155898;
	// 	}

	// 	.shtjBox {
	// 		height: 200px;

	// 		& .swiper {
	// 			height: 200px;
	// 		}
	// 	}
	// }
	.custlbBox{
		::v-deep .dv-scroll-board {
			.rows {
				.ceil{padding:0 5px!important;}
			}
		}
	}
    .custDate .el-date-editor.el-input,
    .custDate .el-date-editor.el-input__inner {
        width: 140px;margin: 0 auto;
    
    }


	.hnzbLable {
		margin-top: 10px;
	}

	.hnzbLable .itemLable {
		line-height: 1;
		border: 1px solid;
		color: #2196f3;
		font-size: 12px;
		padding: 5px 7px;
		border-radius: 1px;
	}

	.hnzbLable .itemLable+.itemLable {
		margin-left: 7px;
	}

	.hnzbLable .itemLable.checked {
		background: #006AF6;
		color: #FFFFFF;
		border-color: #006AF6;
	}

	//调整
	.tabBox .menuBox {
		height: 32px;
		font-weight: normal;
		font-size: 12px;
	}

	.tabBox .menuBox .menuItem {
		padding: 0 12px;
		height: 20px;
		line-height: 20px;
		cursor: pointer;
	}

	.tabBox .menuBox .menuItem.checked {
		background: #2196f3;
	}

	// .notcieIcon {
	// 	width: 16px;
	// 	height: 16px;
	// 	display: inline-block;
	// 	vertical-align: middle;
	// 	margin-right: 5px;
	// }
</style>